import { useEffect, useRef, useState } from 'react'

import { createEmptyFilter, haveFiltersChanged } from '@/common/components/FiltersDrawer/helpers'

const useFiltersDrawer = ({ show, appliedFilters, getInitialFilters, getDefaultFilterValue, isFilterValid }) => {
  const [filters, setFilters] = useState([createEmptyFilter()])
  const snapshotRef = useRef(null)
  const cardRefs = useRef({})
  const appliedFiltersRef = useRef(appliedFilters)
  appliedFiltersRef.current = appliedFilters

  useEffect(() => {
    if (show) {
      const initial = getInitialFilters(appliedFiltersRef.current)
      setFilters(initial)
      snapshotRef.current = initial
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  const handleAddFilter = () => {
    setFilters(prev => [...prev, createEmptyFilter()])
  }

  const handleDeleteFilter = id => {
    setFilters(prev => {
      const next = prev.filter(f => f.id !== id)
      return next.length === 0 ? [createEmptyFilter()] : next
    })
  }

  const handleChangeType = (id, newType) => {
    setFilters(prev =>
      prev.map(f => (f.id === id ? { ...f, type: newType, value: getDefaultFilterValue(newType) } : f))
    )
  }

  const handleChangeValue = (id, updates) => {
    setFilters(prev => prev.map(f => (f.id === id ? { ...f, value: { ...f.value, ...updates } } : f)))
  }

  const handleResetFilters = () => {
    setFilters([createEmptyFilter()])
  }

  const restoreSnapshot = () => {
    if (snapshotRef.current) setFilters(snapshotRef.current)
  }

  const handleClickChip = id => {
    const ref = cardRefs.current[id]
    if (ref) {
      ref.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  const hasActiveFilters = filters.some(f => f.type && isFilterValid(f))
  const areAllFiltersValid = filters.every(isFilterValid)
  const hasChanged = haveFiltersChanged(filters, snapshotRef.current)
  const isApplyDisabled = !hasChanged || !areAllFiltersValid

  return {
    filters,
    cardRefs,
    hasActiveFilters,
    isApplyDisabled,
    handleAddFilter,
    handleDeleteFilter,
    handleChangeType,
    handleChangeValue,
    handleResetFilters,
    handleClickChip,
    restoreSnapshot,
  }
}

export default useFiltersDrawer
